module.exports = __webpack_public_path__ + "static/media/green_box_24dp.a914347f.svg";